import { render, staticRenderFns } from "./Stat.vue?vue&type=template&id=1bd6fe1f&scoped=true"
import script from "./Stat.vue?vue&type=script&lang=js"
export * from "./Stat.vue?vue&type=script&lang=js"
import style0 from "./Stat.vue?vue&type=style&index=0&id=1bd6fe1f&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1bd6fe1f",
  null
  
)

export default component.exports